import React from "react"
import StatCard from "./components/common/StatCard";

import BulkUploadsTable from "./components/tables/BulkUploadsTable";

import AuthManager from "../utils/AuthManager";

export default class Submissions extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      currentUser: AuthManager.currentUser
    }
  }

  componentDidMount() {

  }

  render() {
    let {

    } = this.state

    return (
      <>
        <div className="row">
          <div className="col-sm-12 col-xl-12">
            <BulkUploadsTable
              title={"Bulk Uploads"}
            />
          </div>
        </div>
      </>
    )
  }

}
